export const ContractRouting = [
  {
    path: "/purchase/contract/list",
    name: "purchase-contract-list",
    meta: { title: "采购合同" },
    notice: { type: "purchase_contract_examine", hasNotice: false },
    component: () =>
      import(
        /* webpackChunkName: "purchase-contract" */ "@/views/purchase/contract/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/contract/create",
    name: "purchase-contract-create",
    meta: { title: "新增采购合同", comName: "PurchaseContractFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-contract" */ "@/views/purchase/contract/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/contract/edit/:id",
    name: "purchase-contract-edit",
    meta: { title: "编辑采购合同", comName: "PurchaseContractFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-contract" */ "@/views/purchase/contract/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/contract/detail/:id",
    name: "purchase-contract-detail",
    meta: { title: "采购合同详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-contract" */ "@/views/purchase/contract/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/contract/flowPrint/:id",
    name: "purchase-contract-flowPrint-detail",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-contract" */ "@/views/purchase/contract/flow-print/index.vue"
      ),
  },
];
